import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { ownerNav } from '@/lib/navConfig';
import ExpensesReport from '@/components/expenses/ExpensesReport';

export default function OwnerExpenses() {
  return (
    <AppShell nav={ownerNav} title="Laporan Pengeluaran Operasional" showBell>
      <div className="space-y-4">
        <div className="rounded-lg border bg-sky-50 p-3 text-xs text-sky-900">
          <b>View Owner:</b> Semua pengeluaran yang dicatat oleh Finance/Owner ditampilkan di sini secara terperinci.
          Total pengeluaran otomatis mengurangi <b>Laba Kotor</b> menjadi <b>Laba Bersih</b> di modul Laporan.
        </div>
        <ExpensesReport />
      </div>
    </AppShell>
  );
}
